<template>
  <div>
    <sc-panel-navigator
        v-if="loaded"
        :refresh="clock"
        :drawerWidth="320"
        :processingDrawer="processingFilters"
        @update="mergeBookings($event)"
        @refresh="loadDayData">

      <div
          v-fill-height
          style="padding-left: 5px">
        <div
            style="background-color: #1a8091;padding-top: 3px;padding-bottom: 3px;margin-left: -3px;padding-left: 3px;color: white">
          <el-row type="flex">


            <el-button
                type="text"
                @click="selectAllForPrint()">
              <i class="material-icons">done_all</i>
            </el-button>
            <span
                class="material-icons"
                title="print portrait">portrait</span>
            <el-switch
                v-model="printLandscape"
                active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
            <span
                class="material-icons"
                title="print landscape">crop_landscape</span>

            <span
                class="material-icons"
                title="print continuous">description</span>
            <el-switch
                v-model="breakPages"
                active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
            <span
                class="material-icons"
                title="print every route in a new page">layers</span>
            <el-checkbox style="margin-right: 3px"
                         title="Check it if you want to print booked times as reported by the rep or tour operator"
                         v-model="print_booked_time"><i
                class="el-icon-time" style="color:white;"></i></el-checkbox>
            <el-checkbox title="Check it if you want to print booking references" v-model="printbookrefs"><i
                class="el-icon-collection-tag" style="color:white;"></i></el-checkbox>
          </el-row>
          <el-row flex>
            <el-button
                type="primary"
                plain
                title="Full pickup list"
                v-if="!excrursionMode"

                xdisabled="!routesForPrint"
                @click="downloadRoutes">
              <i class="material-icons">file_download</i>
            </el-button>
            <el-button

                type="primary"
                plain
                title="Full pickup list"
                v-if="!excrursionMode"

                xdisabled="!routesForPrint"
                @click='handlePrint("n-transfers-ppprinter")'>
              <i class="material-icons">print</i>
            </el-button>
            <el-button
                type="primary"
                plain
                title="Full pickup list"
                v-if="!excrursionMode"

                xdisabled="!routesForPrint"
                @click='handlePrint("n-transfers-ppprinter-compact")'>
              <i class="material-icons">directions_bus</i>
            </el-button>
            <el-button
                type="success"
                plain
                title="Full pickup list"
                v-if="!excrursionMode"

                xdisabled="!routesForPrint"
                @click='handlePrint("n-pp-synopsy")'>
              <i class="material-icons">grid_on</i>
            </el-button>
            <el-button
                type="success"
                plain
                title="Full pickup list"
                v-if="!excrursionMode"

                xdisabled="!routesForPrint"
                @click='handlePrint("n-pp-synopsy",{printimes:1})'>
              <i class="material-icons">grid_on</i> <i class="material-icons">schedule</i>
            </el-button>
            <a
                href="javascript:void(0)"
                title="Full pickup list"
                v-if="excrursionMode"
                class="btn btn-xs btn-raised btn-default"
                :disabled="!routesForPrint"
                @click='goPdf("[[!+domain]]-excursions-printer.html",{printbookrefs:(printbookrefs)?1:0,printimes:(printimes)?1:0,plandate:plandate,multiplepages:multiplepages,tripids:selectedTrips,cooptions:selectedCompanies,selectedRoutes:routesForPrint});'>
              <i class="material-icons">print</i>
            </a>
          </el-row>
        </div>
        <el-row style="padding-top: 3px">
          <el-col :span="20">
            <el-date-picker
                v-model="plandate"
                :picker-options="{firstDayOfWeek:1}"
                value-format="d/M/yyyy"
                xclass="el-bootstrap"
                style="width:100%;margin-left:8px;"
                format="dd/MM/yyyy"
                type="date"

                @change="loadDayData"
                placeholder="Pick a day"/>
          </el-col>
          <el-col :span="4">
            <el-button
                style="padding: 10px;margin-left: 6px;"
                @click="loadDayData"
                icon="el-icon-refresh-right"

                type="success">

            </el-button>
          </el-col>
          <el-col :span="24" style="padding: 4px">
            <el-input v-model="bkSearch" clearable placeholder="search refer., ticket or name"></el-input>
          </el-col>

        </el-row>


        <bookings-selector
            ref="tripFilters"
            :transfer-data="dayBookings"
            single-trips
            @select="workingCompanies=$event.selected_companies;workingTrips=$event.selected_trips"></bookings-selector>
      </div>


    </sc-panel-navigator>
    <h3 v-else>loading...</h3>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import * as api from "~/api/resource";
import _ from "lodash";
import * as dateHelper from "date-fns";
// import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";
import ScPanelNavigator from "../../Layout/PanelNavigator";
import BookingsSelector from "../../Form/BookingsSelector";
import {html_ajax_download} from "../../../api/resource";

export default {
  components: {BookingsSelector, ScPanelNavigator},
  mixins: [printHtml],
  props: {
    useTripTypeFilterOnDataLoad: {default: true, type: Boolean},
    isExcrs: {default: false, type: Boolean}
  },
  data() {
    return {
      clock: 0,

      processingFilters: true,
      printLandscape: true,
      print_booked_time: false,
      breakPages: false,
      wTripTypes: this.isExcrs ? ["EXCRS"] : ["ARV",
        "DEP"],
      // plandate: null,
      workingTrips: [],
      companiesOnDay: [],
      workingCompanies: [],
      dayBookings: [],
      // selectedCompanies:[],
      selectedRoutes: null,
      routesForPrint: null, excrursionMode: false, hidePrivate: false,
      multiplepages: false, printimes: false, printbookrefs: false,
      printData: null,
      printReady: false,
      loaded: false,

    };
  },
  watch: {
    '$route.params.trips'(v, vo) {
      if (v == vo) return
      this.loadDayData()
    }
  },
  methods: {
    downloadRoutes() {
      api.html_ajax_download('vue_booking/getlist', {
        plandate: this.plandate,
        coids: this.workingCompanies,
        download: 'transfers',
        sort: 'finalPickupTime',
        dir: 'ASC',
        limit: 0
      })
    },
    mergeBookings(bks) {
      const loadedBks = JSON.parse(JSON.stringify(this.dayBookings))
      bks.forEach(bk => {
        const bki = this.findInArray(loadedBks, {bk_id: bk.bk_id}, true)
        if (bki >= 0) loadedBks[bki] = bk
        else {
          _log_('problem,', bki, bk, loadedBks[bki])
          alert('problem with booking sing')
        }
        // _log_('bk,', bk)
      })
      this.dayBookings = loadedBks
    },
    handlePrint(what, extraParams) {

      let coms = {
        range: this.plandate + '-' + this.plandate,
        limit: 0,
        type: "full",
        for: "routing",
      };
      if (this.useTripTypeFilterOnDataLoad)
        coms.tripTypes = this.$route.params.trips || this.$route.query.trip_types
      if (this.breakPages) coms.breakPages = true
      if (this.printbookrefs) coms.printbookrefs = 1
      if (this.print_booked_time) coms.print_booked_time = 1
      if (extraParams) coms = {...coms, ...extraParams}
      if (this.$route.query.booking_filter) coms.booking_filter = this.$route.query.booking_filter
      if (this.$route.query.filter_mode) coms.filter_mode = this.$route.query.filter_mode
      if (this.$route.query.checkedRoutes) coms.checkedRoutes = this.$route.query.checkedRoutes
      _log_('handlePrint', coms)
      this.goPdf(what + (!this.printLandscape ? '-p' : '') + ".html", coms)
      // this.goPdf("transfers-ppprinter.html", {
      //   // printbookrefs: (printbookrefs) ? 1 : 0,
      //   // printimes: (printimes) ? 1 : 0,
      //   // multiplepages: multiplepages,
      //   plandate: this.plandate,
      //
      //   tripids: selectedTripsArr.join(','),
      //   cooptions: selectedCompaniesArr.join(','),
      //   selectedRoutes: this.$route.query.checkedRoutes
      // });

    },
    selectAllForPrint() {
      if (this.$route.query.select_routes == 'all')
        this.routeGo({query: {select_routes: null}}, true)
      else
        this.routeGo({query: {select_routes: 'all'}}, true)
    },
    getTripsForType(tripType) {
      _log_('sorting....' + tripType);
      if (!this.selectedRoutes || !tripType) return
      return this.selectedRoutes.filter(e => tripType == e.tripType)
          .sort(function (a, b) {
            //    _log_('sorting....' + (a.time - b.time));
            return a.time - b.time;
          });
    },
    async toggleTrips(toggleTrips) {

      this.routeGo({
        name: this.$route.name == 'route_composer' ? 'composer_for_day' : 'composer_for_day_v_a',
        params: {trips: toggleTrips},
        query: {date: this.plandate}
      })

      //toggleElement('selectedTrips',fl.id); pipeActions(['->prepareTripSelection','=>route/composer','->setData'],{tripids:selectedTrips,cooptions:selectedCompanies});
      //toggleAllTrips('ARV',true); pipeActions(['->prepareTripSelection','=>route/composer','->setData'],{tripids:selectedTrips,cooptions:selectedCompanies});
    },
    toggleCompany(co) {
      _log_('toggleTrips....', co);
      this.selectedCos = this.toggleElement(this.selectedCos, co.co_id, true)
      // clearLoadedTrips();toggleElement('selectedCompanies',co.co_id);pipeActions(['=>scheduletrip/getlist','->cacheTrips'],{limit:0,plandate:plandate,tripTypes:wTripTypes,intercontext:'transits',cooptions:selectedCompanies});
    },
    async loadDayData(trips) {
      _log_('trips...', trips)
      this.processingFilters = true
      let coms = {
        for: 'routing',
        limit: 0,
        type: 'full',
        execStatus: 'notcanceled',
        // tripTypes: this.$route.params.trips,
        plandate: this.plandate,
      }
      if (this.useTripTypeFilterOnDataLoad)
        coms.tripTypes = this.$route.params.trips || this.$route.query.trip_types
      this.dayBookings = await api.getModxList('vue_booking', coms)
      // _log_('trips...', trips)
      // this.$refs.tripFilters.resetFilters()
      // this.$router.push({
      //   name: 'composer_for_day',
      //   params: {trips: this.$route.params.trips ? this.$route.params.trips : this.wTripTypes.join(',')},
      //   query: {date: this.plandate}
      // })
      this.processingFilters = false
      ++this.clock
      // _log_('cos...', cos)
      //clearData(true);pipeActions(['=>scheduletrip/getlist','->cacheTrips'],{haspax:excrursionMode,sort:'time',limit:0,plandate:plandate,tripTypes:wTripTypes,intercontext:'transits'});
      // pipeActions(['=>booking/getoptions>=companiesOnDay'],{plandate:plandate,tripTypes:wTripTypes,distinctfield:'companies',intercontext:'transits'});
    },
    updateTable(msg) {

      this.$refs.packageList.updateOrAppendRow(msg);
    },

  },
  async mounted() {
    const {data} = await api.fetchProcessor("vue_route/autocomposer", {

      do: "enableRouteReport",

    });
    if (this.$route.query.date) {
      this.plandate = this.$route.query.date
      // this.wTripTypes=this.$route.params.trips.split(',')
      this.loadDayData(this.$route.params.trips)
    }

    this.loaded = true;
    // _log_("the rs///", this.$route);
  },// query: {date: this.plandate}
  computed: {
    bkSearch: {
      get() {
        return this.$route.query.search
      },
      set(v) {
        this.routeGo({query: {search: v}}, true)
      }
    },
    plandate: {
      get() {
        return this.$route.query.date
      },
      set(v) {
        this.routeGo({query: {date: v, booking_filter: null}})
      }
    },
    selectedCos: {
      get() {
        return this.$route.query.selectedCos
      },
      set(v) {
        this.routeGo({query: {selectedCos: v}})
      }
    },
    colTripDefinitions() {
      var rw = "580px",
          vm = this;
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        {prop: "title", width: "", label: "Package"},
        {prop: "year", width: "", label: "Date", formatterType: "unxToDate"},
      ];
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style>
